module.exports = __webpack_public_path__ + "img/5-10-15-shuttle-sprint.2860d741.png";